import * as React from 'react';
import {Registry} from './Registry';

// Please, do not move RegistryContext definition to Registry.ts. Registry is used also in clientlibs-priority.
// Moving registry context to Registry.ts would include react to clientlibs-priority bundle.
export const RegistryContext = React.createContext<Registry | null>(null);
